import React from 'react';
import { Modal, Button } from 'antd';
import './CancelEnterpriseSubscription.scss';

const CancelEnterpriseSubscription = ({
    visible,
    onClose,
    confirmCancellation,
    cancelLoader,
    onContactSales
}) => {
    return (
        <Modal
            centered
            closable
            maskClosable={false}
            visible={visible}
            onCancel={onClose}
            footer={null}
            className="cancel-enterprise-confirm-modal"
            destroyOnClose={true}
            width={600}>

            <div className="sub-cancel-content">
                <div className="manrope f-20 w-500 black-085 lh-28 mb-24">
                    Are you sure you want to cancel?
                </div>

                <div className="manrope f-14 w-500 black-085 lh-22 mb-24">
                    You can always modify your subscription, or purchase any of the credits you need.
                </div>
                <div className="justify-in-end cancel-actions">
                    <Button
                        className="skip-button"
                        onClick={onContactSales}>
                        Contact Sales
                    </Button>
                    <Button
                        loading={cancelLoader}
                        className="schedule-button"
                        onClick={() => { confirmCancellation(); onClose(); }}>
                        Confirm request
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CancelEnterpriseSubscription;
